import { render } from "./AgreementPersonalDataView.vue?vue&type=template&id=5f37a2d6"
import script from "./AgreementPersonalDataView.vue?vue&type=script&lang=js"
export * from "./AgreementPersonalDataView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/demo-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__